export default __webpack_public_path__ + "static/img2-9fdfea37935c492fddc7b6026ea72a90.webp";